import { useScaleFactor as e } from "../../hooks/useScaleFactor.js";
import "../../hooks/index.js";
import t from "./Skeleton.module.js";
import { c as n } from "react/compiler-runtime";
import r from "classnames";
import { memo as i } from "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/Skeleton/Skeleton.tsx
var s = 200, c = "skeleton", l = i((i) => {
	let l = n(36), { circle: u, className: d, innerRadius: f, outerRadius: p, width: m, height: h } = i, g = u !== void 0 && u, _ = d === void 0 ? "" : d, v = e(), y;
	l[0] === v ? y = l[1] : (y = (e, t) => e == null ? void 0 : e * (t === void 0 ? v : t), l[0] = v, l[1] = y);
	let b = y, x;
	l[2] !== h || l[3] !== f || l[4] !== p || l[5] !== m || l[6] !== b ? (x = [
		f,
		p,
		m,
		h
	].map((e) => b(e)), l[2] = h, l[3] = f, l[4] = p, l[5] = m, l[6] = b, l[7] = x) : x = l[7];
	let [S, C, w, T] = x, E;
	l[8] !== g || l[9] !== T || l[10] !== C || l[11] !== w ? (E = g ? {
		borderRadius: "50%",
		height: C ? C * 2 : void 0,
		width: C ? C * 2 : void 0
	} : {
		height: T,
		width: w
	}, l[8] = g, l[9] = T, l[10] = C, l[11] = w, l[12] = E) : E = l[12];
	let D = E, O;
	l[13] !== g || l[14] !== T || l[15] !== C || l[16] !== w ? (O = g ? {
		height: C ? C * 2 : void 0,
		width: C ? C * 2 + s : void 0
	} : {
		height: T,
		width: w ? w + s : void 0
	}, l[13] = g, l[14] = T, l[15] = C, l[16] = w, l[17] = O) : O = l[17];
	let k = O, A;
	if (g && S && C) {
		let e = Math.min(S, C), t = e * 2, n = C - e + "px", r = C - e + "px", i = e * 2, a;
		l[18] !== i || l[19] !== t || l[20] !== n || l[21] !== r ? (a = {
			height: t,
			left: n,
			top: r,
			width: i
		}, l[18] = i, l[19] = t, l[20] = n, l[21] = r, l[22] = a) : a = l[22], A = a;
	} else {
		let e;
		l[23] === Symbol.for("react.memo_cache_sentinel") ? (e = { display: "none" }, l[23] = e) : e = l[23], A = e;
	}
	let j = A, M;
	l[24] === _ ? M = l[25] : (M = r(t.container, _), l[24] = _, l[25] = M);
	let N = i["data-test"] ?? c, P;
	l[26] === k ? P = l[27] : (P = /* @__PURE__ */ a("div", {
		className: t.background,
		style: k
	}), l[26] = k, l[27] = P);
	let F;
	l[28] === j ? F = l[29] : (F = /* @__PURE__ */ a("div", {
		className: t.innerCircle,
		style: j
	}), l[28] = j, l[29] = F);
	let I;
	return l[30] !== D || l[31] !== F || l[32] !== M || l[33] !== N || l[34] !== P ? (I = /* @__PURE__ */ o("div", {
		className: M,
		style: D,
		"data-test": N,
		children: [P, F]
	}), l[30] = D, l[31] = F, l[32] = M, l[33] = N, l[34] = P, l[35] = I) : I = l[35], I;
});
//#endregion
export { l as Skeleton };
